import React from 'react';
import { Button as ResetButton, Button as SubmitButton } from 'react-bootstrap';
import PropTypes from 'prop-types';

function SubmitResetButtons({ isSubmitting, handleSubmit, setResetCount, resetForm, navTitles, setNavTitles }) {
    return (
        <div className="d-flex my-3">
            <SubmitButton
                disabled={isSubmitting}
                as="input"
                size="lg"
                type="submit"
                value={isSubmitting ? 'Submitting...' : 'Submit'}
                className={'mr-auto bg-info border border-info'}
                onClick={handleSubmit}
            />
            <ResetButton
                disabled={isSubmitting}
                type="button" //(1)don't use type="reset" as it cannot reset value to original ones in formik.
                as="input"
                size="lg"
                value="Reset"
                className={'border  bg-warning  border-warning'}
                onClick={() => {
                    if (setResetCount) setResetCount((prev) => ++prev);

                    resetForm();

                    if (navTitles.length > 0) {
                        navTitles.forEach((item) => (item.hasError = false));
                        setNavTitles(JSON.parse(JSON.stringify(navTitles)));
                    }
                }}
            />
        </div>
    );
}
SubmitResetButtons.defaultProps = {
    navTitles: [],
    setNavTitles: null,
    setResetCount: null,
};
SubmitResetButtons.propTypes = {
    isSubmitting: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    setResetCount: PropTypes.func,
    resetForm: PropTypes.func.isRequired,
    navTitles: PropTypes.array,
    setNavTitles: PropTypes.func,
};

export default SubmitResetButtons;
